function setRem() {
  const designWidth = 1920 // 你的设计稿宽度（常用 1920 / 750）
  const html = document.documentElement
  const fontSize = html.clientWidth / designWidth * 16
  html.style.fontSize = fontSize + 'px'
}
setRem()
window.onresize = setRem